import { load as loadRecaptcha } from "recaptcha-v3";
import { Surreal } from "surrealdb";

const SURREAL_HOST = process.env.SURREAL_HOST || "";
const SURREAL_NAMESPACE = process.env.SURREAL_NAMESPACE || "";
const SURREAL_DATABASE = process.env.SURREAL_DATABASE || "";
const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY || "";

export async function connect(connection: Surreal) {
  await connection.connect(SURREAL_HOST, {
    namespace: SURREAL_NAMESPACE,
    database: SURREAL_DATABASE,
  });
}

export async function signup({
  connection,
  code,
}: {
  connection: Surreal;
  code: string;
}) {
  const recaptcha = await loadRecaptcha(RECAPTCHA_KEY);
  const token = await recaptcha.execute("submit");
  return connection.signup({
    access: "admin",
    variables: {
      code,
      name: code,
      captcha: token,
    },
  });
}

export function signin({
  connection,
  code,
  access,
}: {
  connection: Surreal;
  code: string;
  access: "admin" | "user";
}) {
  return connection.signin({
    access,
    variables: {
      code,
    },
  });
}
